module.exports = __webpack_public_path__ + "img/PAGE_REFERENCES.3e45944f.svg";